import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
	OrderApi,
	OrderItemApi,
	TaxItemApi,
} from "../../../../../../../../../../../../services/Api/Organization/types";
import OrderFormItemsSummaryTableBody from "./OrderFormItemsSummaryTableBody";
import OrderFormItemsSummaryTableButtons from "./OrderFormItemsSummaryTableButtons";
import OrderFormItemsSummaryTableHeader from "./OrderFormItemsSummaryTableHeader";

interface Props {
	form: UseFormReturn<OrderApi>;
	summaryTaxes: TaxItemApi[];
	recalculateSummaryTaxes: (
		items: OrderItemApi[],
		taxGross: boolean,
		index?: number,
		val?: number,
		quantity?: string
	) => void;
}

const OrderFormItemsSummaryTable = ({ form, summaryTaxes, recalculateSummaryTaxes }: Props) => {
	return (
		<div className="row positions-table-summary">
			<div className="col-md-6" />
			<div className="col col-md-6">
				<OrderFormItemsSummaryTableButtons form={form} recalculateSummaryTaxes={recalculateSummaryTaxes} />
				<div className="table-responsive">
					<table className="table table-preview mt-3">
						<OrderFormItemsSummaryTableHeader />
						<OrderFormItemsSummaryTableBody summaryTaxes={summaryTaxes} />
					</table>
				</div>
			</div>
		</div>
	);
};

export default OrderFormItemsSummaryTable;
